"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingFilterData = void 0;
function mapSettingFilterData(data) {
    const filter = [];
    if (data.search) {
        filter.push({
            column: 'search',
            op: 'full-text-query',
            value: data.search,
        });
    }
    if (data.name) {
        filter.push({
            column: 'name',
            op: '=',
            value: data.name,
        });
    }
    if (data.public != null) {
        filter.push({
            column: 'public',
            op: '=',
            value: data.public,
        });
    }
    if (data.changed != null) {
        filter.push({
            column: 'changed',
            op: '=',
            value: data.changed,
        });
    }
    return filter;
}
exports.mapSettingFilterData = mapSettingFilterData;
